import React, { useState, useEffect } from "react";
import "./Messages.css";

const Message =(props) =>{
  useEffect(()=>{
  },[]);
  let items= props.items.map((item,index)=>{
    return <div  key={index} style={{backgroundImage: !!item.MashanTopMobileImage ? `url(${item.MashanTopMobileImage.ImageUrl})`: ''}} >
        <div className="message-child-wrapper col-12 col-md-9" >
          {!!item.MashanTopDesktopImage && <div className="container-message-img  col-12 col-md-6"><img src={item.MashanTopDesktopImage.ImageUrl} /></div>}
            <div className="message-title-text col-12 col-md-6">
                {item.ContainerTitle}
                <div className="message-text" dangerouslySetInnerHTML={{__html:item.RichTextContainer}}></div>
                {!!item.MashanContainerLink &&
                <a className="message-link" href={item.MashanContainerLink.NavigateUrl} >{item.MashanContainerLink.Text}
                </a>}
            
                </div>
                </div>
        </div>
});
    return (
          <div className="container-message-wrapper row" >
              {items}
          </div>
    )
}


export default Message;